import { Naps, NapsQGIS } from "@/shared/interfaces";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import SemaforoPuertos from "./SemaforoPuertos";
import { SwitchComponente } from "@/shared/components/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import { hasPermission, ROUTER_PATHS } from "@/shared";
import { useUiConfirmModalStore } from "@/store/ui";
import { toast } from "react-toastify";
import { useUpdateNaps } from "@/shared/actions/erp";
import { useNavigate } from "react-router-dom";

export const useColumnsNaps = () => {
    const navigate = useNavigate();
    const returnUrlNaps = ROUTER_PATHS.configuracionRED.napsNav;
    const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
    const setConfirmDialogIsOpen = useUiConfirmModalStore(
        s => s.setConfirmDialogIsOpen
    );
    const updateNapsMutation = useUpdateNaps({navigate, returnUrl:returnUrlNaps});

    const columnsNap = useMemo<MRT_ColumnDef<Naps>[]>(
        () => [
        {
            accessorKey: 'nombre',
            header: 'nombre',
            size: 200,
        },
        {
            accessorKey: 'disponibilidad_puertos',
            header: 'disponibilidad de puertos',
            size: 200,
            Cell: ({ row }) => <SemaforoPuertos nap={row.original} />,
            enableColumnFilter: false,
            enableSorting: false,
        },
        {
            accessorKey: 'coordenadas',
            header: 'Coordenadas',
            size: 200,
        },
        {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
            <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={estado => {
                if (!hasPermission(PermissionsEnum.api_change_nap)) return;
                setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                    '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    if(!row.original.caja_primaria && estado){
                    toast.error('No se puede activar un NAP que no tenga una caja primaria');
                    return; 
                    }
                    updateNapsMutation.mutate({
                    id: row.original.id_nap!,
                    data: {
                        ...row.original,
                        estado: estado as boolean,
                    },
                    });
                },
                });
            }}
            />
        ),
        },
        ],
        []
    );


    const columnsNapQGIS = useMemo<MRT_ColumnDef<NapsQGIS>[]>(
        () => [
            { accessorKey: 'id', header: 'ID', size: 80 },
            // { accessorKey: 'geom', header: 'Geom', size: 150 },
            { accessorKey: 'nombre', header: 'Nombre', size: 200 },
            { accessorKey: 'descriptio', header: 'Descripción', size: 250 },
            { accessorKey: 'status', header: 'ESTADO', size: 120 },
            { accessorKey: 'proyecto_cod', header: 'Código Proyecto', size: 180 },
            { accessorKey: 'coordenada', header: 'Coordenada', size: 180 },
            { accessorKey: 'puertos_oc', header: 'Puertos OC', size: 120 },
            { accessorKey: 'fecha_instalacion', header: 'Fecha Instalación', size: 180 },
            { accessorKey: 'solicita', header: 'Solicita', size: 180 },
            { accessorKey: 'sector', header: 'Sector', size: 150 },
            { accessorKey: 'ciudad', header: 'Ciudad', size: 150 },
            { accessorKey: 'tecnico_in', header: 'Técnico', size: 180 },
            { accessorKey: 'potencia', header: 'Potencia', size: 120 },
            { accessorKey: 'project_name', header: 'Nombre Proyecto', size: 200 },
            { accessorKey: 'id_poligono', header: 'ID Polígono', size: 120 },
            { accessorKey: 'soterrada', header: 'Soterrada', size: 120 },
            { accessorKey: 'splitter', header: 'Splitter', size: 120 },
            { accessorKey: 'operadora', header: 'Operadora', size: 180 },
        ],
        []
    );
    return {
        columnsNap,
        columnsNapQGIS
    }
}